export default "__VITE_ASSET__D8h19KQB__"